import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4060b38b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4060b38b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060b38b",
  null
  
)

export default component.exports